import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_down",
  "use": "icon-arrow_down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow_down\"><path d=\"M512 562.005333l181.034667-181.034666a42.666667 42.666667 0 1 1 60.330666 60.330666l-211.2 211.2a42.666667 42.666667 0 0 1-60.330666 0l-211.2-211.2a42.666667 42.666667 0 1 1 60.330666-60.330666L512 562.005333z\" fill=\"#367279\" p-id=\"15351\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol